export const API_GET_ALL_COSTUMER = "/admin/clientes/";
export const API_GET_SEARCH_COSTUMERS = "/admin/clientes/buscar/";
export const API_POST_SAVE_COSTUMERS = "/admin/clientes/registro-cliente";
export const API_POST_SAVE_PROVAIDER = "/admin/proveedores/registro-proveedor";
export const API_PUT_UPDATE_COSTUMERS = "/admin/clientes/actualizar-cliente/";
export const API_GET_ALL_LOCATIONS = "/admin/ubicacionGeografica/unificada";